import { useCallback } from 'react';

import { useInstitutionOnboardingBasePath } from '@/features/institution/context/update';
import { useInstitutionDetailsLocked, useInstitutionDetailsV2Answers } from '@/features/institution/hooks/useInstitutionDetails';
import { getFollowingV2OnboardingDetailsKey, getV2OnboardingDetailsKeyRoute } from '@/features/institution/utils';
import type { InstitutionDetailsV2OnboardingKey, InstitutionDetailsV2Submission } from '@/services/api/profile';

/**
 * Where Continue goes from a section: the next one that applies and isn't fully locked, or the review.
 * The returned function takes the answers just saved, as they can change which sections apply.
 */
export const useInstitutionOnboardingNextDetailsRoute = (key: InstitutionDetailsV2OnboardingKey) => {
  const onboardingPath = useInstitutionOnboardingBasePath();
  const { data: institutionDetailsAnswers } = useInstitutionDetailsV2Answers();
  const { fullyLockedKeys } = useInstitutionDetailsLocked();

  return useCallback(
    (savedAnswers: InstitutionDetailsV2Submission) => {
      const nextKey = getFollowingV2OnboardingDetailsKey({ ...institutionDetailsAnswers, ...savedAnswers }, key, fullyLockedKeys);

      return getV2OnboardingDetailsKeyRoute(onboardingPath, nextKey ?? 'authorisation');
    },
    [fullyLockedKeys, institutionDetailsAnswers, key, onboardingPath],
  );
};
